import styled from 'styled-components'
import { blue } from '../../styles/variables.js'

const Library = styled.div`
  flex: 1 1;
  min-width: 500px;
  display: flex;
  flex-direction: column;
  min-height: 65vh;
  max-height: 70vh;
`

const LibraryList = styled.div`
  flex: 1 1;
  padding: 1px;
  display: flex;
  flex-direction: row;
`

const Title = styled.div`
  color: ${blue};
  font-weight: bold;
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 5px;
`

export default {
  Library,
  LibraryList,
  Title,
}
